module.exports = __webpack_public_path__ + "/images/cover-regalos-help.e972570.svg";